{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified Spanish-speaking clinical research professional before activating locale=es in production.",
  "app": {
    "name": "OneVerse",
    "loading": "Cargando...",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "confirm": "Confirmar",
    "submit": "Enviar",
    "edit": "Editar",
    "close": "Cerrar",
    "back": "Volver",
    "next": "Siguiente",
    "search": "Buscar",
    "filter": "Filtrar",
    "export": "Exportar",
    "yes": "Sí",
    "no": "No",
    "required": "Obligatorio",
    "optional": "Opcional",
    "none": "Ninguno",
    "unknown": "Desconocido",
    "error": "Ocurrió un error. Por favor intente de nuevo.",
    "powered_by": "Desarrollado por {{name}}"
  },
  "nav": {
    "home": "Inicio",
    "dashboard": "Panel",
    "submissions": "Solicitudes",
    "studies": "Estudios",
    "sites": "Sitios",
    "users": "Usuarios",
    "settings": "Configuración",
    "notifications": "Notificaciones",
    "admin": "Administración",
    "help": "Ayuda",
    "sign_out": "Cerrar sesión",
    "logout": "Salir",
    "expand_sidebar": "Expandir barra lateral",
    "collapse_sidebar": "Colapsar barra lateral"
  },
  "auth": {
    "sign_in": "Iniciar sesión",
    "sign_in_button": "Iniciar sesión",
    "sign_out": "Cerrar sesión",
    "email": "Correo electrónico",
    "email_placeholder": "Ingrese su correo electrónico",
    "password": "Contraseña",
    "password_placeholder": "Ingrese su contraseña",
    "forgot_password": "¿Olvidó su contraseña?",
    "reset_password": "Restablecer contraseña",
    "enter_reset_code": "Ingrese el código de restablecimiento",
    "reset_code_instructions": "Ingrese su correo electrónico y le enviaremos un código para restablecer su contraseña.",
    "new_code_instructions": "Ingrese el código y su nueva contraseña.",
    "send_reset_code": "Enviar código de restablecimiento",
    "sending": "Enviando...",
    "reset_password_action": "Restablecer contraseña",
    "resetting": "Restableciendo...",
    "create_account": "Crear cuenta",
    "welcome": "Bienvenido a OneVerse",
    "remember_password": "¿Recuerda su contraseña?",
    "confirmation_code": "Código de confirmación",
    "confirmation_code_placeholder": "Ingrese el código de su correo o mensaje de texto",
    "new_password": "Nueva contraseña",
    "new_password_placeholder": "Ingrese su nueva contraseña",
    "confirm_password": "Confirmar nueva contraseña",
    "confirm_password_placeholder": "Confirme su nueva contraseña",
    "mfa": {
      "code": "Código",
      "back_to_login": "Volver al inicio de sesión",
      "sms_placeholder": "Ingrese el código enviado a su teléfono",
      "email_placeholder": "Ingrese el código enviado a su correo",
      "totp_placeholder": "Ingrese el código de su aplicación autenticadora"
    },
    "show_password": "Mostrar contraseña",
    "hide_password": "Ocultar contraseña",
    "errors": {
      "invalid_credentials": "Correo electrónico o contraseña inválidos.",
      "account_locked": "Su cuenta ha sido bloqueada. Por favor contacte soporte.",
      "session_expired": "Su sesión ha expirado. Por favor inicie sesión de nuevo.",
      "email_required": "El correo electrónico es obligatorio",
      "email_password_required": "El correo electrónico y la contraseña son obligatorios",
      "all_fields_required": "Todos los campos son obligatorios",
      "passwords_dont_match": "Las contraseñas no coinciden",
      "unexpected": "Ocurrió un error inesperado",
      "server_non_json": "El servidor devolvió una respuesta no JSON. Revise la consola."
    },
    "welcome_back": "Bienvenido de nuevo",
    "subtitle": "Por favor, ingrese sus datos.",
    "no_account": "¿No tienes cuenta?",
    "sign_up": "Registrarse"
  },
  "dashboard": {
    "welcome": "Bienvenido, {{name}}",
    "new_submission": "Nueva solicitud",
    "submission_overview": "Resumen de solicitudes",
    "view_all_submissions": "Ver todas las solicitudes",
    "recent_activity": "Actividad reciente",
    "no_recent_activities": "Sin actividad reciente.",
    "search_placeholder": "Buscar",
    "total": "Total",
    "submission_singular": "solicitud",
    "submission_plural": "solicitudes",
    "active_site_status": "Estado del sitio activo",
    "view_study": "Ver estudio",
    "loading_studies": "Cargando estudios...",
    "select_study": "Seleccionar estudio",
    "view_details": "Ver detalles",
    "news_and_notes": "Noticias y notas",
    "no_recent_posts": "Sin publicaciones recientes.",
    "failed_to_load_announcements": "Error al cargar anuncios",
    "statuses": {
      "response_required": "Respuesta requerida",
      "drafts": "Borradores",
      "submitted": "Enviado",
      "pre_review": "Revisión previa",
      "irb_review": "Revisión IRB",
      "post_review": "Post-revisión",
      "expiring_soon": "Por vencer"
    }
  },
  "submissions": {
    "title": "Solicitudes",
    "new": "Nueva solicitud",
    "empty": "No se encontraron solicitudes.",
    "status": {
      "pending": "Pendiente",
      "under_review": "En revisión",
      "approved": "Aprobado",
      "rejected": "Rechazado",
      "revisions_required": "Revisiones requeridas",
      "withdrawn": "Retirado",
      "expired": "Expirado",
      "closed": "Cerrado",
      "draft": "Borrador",
      "submitted": "Enviado",
      "pre_review": "Pre-revisión",
      "irb_review": "Revisión IRB",
      "post_review": "Post-revisión",
      "response_required": "Respuesta requerida",
      "expiring_soon": "Por vencer",
      "complete": "Completado",
      "deleted": "Eliminado"
    },
    "fields": {
      "title": "Título",
      "protocol_number": "Número de protocolo",
      "principal_investigator": "Investigador principal",
      "submitted_at": "Enviado",
      "updated_at": "Última actualización",
      "status": "Estado",
      "type": "Tipo",
      "id": "ID",
      "submitted": "Enviado",
      "expiration": "Fecha de expiración"
    },
    "actions": {
      "view": "Ver solicitud",
      "edit": "Editar solicitud",
      "withdraw": "Retirar",
      "submit": "Enviar para revisión"
    },
    "empty_yet": "Aún no hay solicitudes.",
    "search_placeholder": "Buscar por ID o título",
    "filter": {
      "all_statuses": "Todos los estados",
      "all_types": "Todos los tipos",
      "status_label": "Estado",
      "type_label": "Tipo"
    },
    "errors": {
      "failed_to_load": "Error al cargar las solicitudes"
    }
  },
  "studies": {
    "title": "Estudios",
    "new": "Nuevo estudio",
    "empty": "No se encontraron estudios.",
    "fields": {
      "title": "Título del estudio",
      "irb_number": "Número IRB",
      "pi": "Investigador principal",
      "status": "Estado",
      "start_date": "Fecha de inicio",
      "end_date": "Fecha de fin",
      "id": "ID",
      "type": "Tipo",
      "submitted": "Enviado",
      "expiration": "Fecha de expiración"
    },
    "empty_yet": "Aún no hay estudios.",
    "search_placeholder": "Buscar por ID o título",
    "filter": {
      "all_statuses": "Todos los estados",
      "all_types": "Todos los tipos",
      "type_label": "Tipo",
      "attribute_label": "Atributo",
      "all_attributes": "Todos los atributos",
      "attribute_value_placeholder": "Valor del atributo"
    },
    "errors": {
      "failed_to_load": "Error al cargar los estudios"
    },
    "standalone": "independiente",
    "sort_by": "Ordenar por {{column}}",
    "attributes": {
      "cro": "CRO",
      "sponsor": "Patrocinador",
      "pi": "PI",
      "pi_email": "Email del PI",
      "poc": "POC",
      "poc_email": "Email del POC",
      "poc_phone": "Teléfono del POC",
      "poc_role": "Rol del POC"
    }
  },
  "sites": {
    "title": "Sitios",
    "new": "Nuevo sitio",
    "empty": "No se encontraron sitios.",
    "empty_yet": "Aún no hay sitios.",
    "search_placeholder": "Buscar por ID, nombre del sitio o IP",
    "filter": {
      "all_statuses": "Todos los estados",
      "all_countries": "Todos los países",
      "country_label": "País"
    },
    "errors": {
      "failed_to_load": "Error al cargar los sitios"
    },
    "fields": {
      "id": "ID",
      "site_name": "Nombre del sitio",
      "country": "País",
      "protocol_number": "Número de protocolo",
      "sponsor_name": "Nombre del patrocinador",
      "pi_name": "Nombre del IP",
      "approved": "Aprobado",
      "expiration": "Fecha de expiración",
      "status": "Estado"
    }
  },
  "errors": {
    "not_found": "El recurso solicitado no fue encontrado.",
    "unauthorized": "No está autorizado para realizar esta acción.",
    "server_error": "Ocurrió un error en el servidor. Por favor intente más tarde.",
    "network_error": "Ocurrió un error de red. Por favor verifique su conexión.",
    "not_found_title": "Perdimos esta página",
    "not_found_body": "La página que buscas no existe o ha sido movida.",
    "go_back": "Volver"
  },
  "pagination": {
    "previous": "Anterior",
    "next": "Siguiente",
    "page": "Página {{current}} de {{total}}",
    "showing": "Mostrando {{from}}–{{to}} de {{total}}"
  },
  "dates": {
    "today": "Hoy",
    "yesterday": "Ayer",
    "just_now": "Ahora mismo",
    "ago": "Hace {{time}}"
  },
  "entity": {
    "status": {
      "in_progress": "En progreso",
      "active": "Activo",
      "rejected": "Rechazado",
      "suspended": "Suspendido",
      "closed": "Cerrado",
      "expired": "Expirado"
    }
  },
  "activities": {
    "submission_approved": "Solicitud aprobada",
    "submission_created": "Solicitud creada",
    "submission_submitted": "Solicitud enviada",
    "submission_updated": "Solicitud actualizada",
    "submission_withdrawn": "Solicitud retirada",
    "submission_rejected": "Solicitud rechazada",
    "submission_expired": "Solicitud expirada",
    "study_created": "Estudio creado",
    "study_updated": "Estudio actualizado",
    "site_created": "Sitio creado",
    "site_updated": "Sitio actualizado",
    "status_changed": "Estado cambiado",
    "review_started": "Revisión iniciada",
    "review_completed": "Revisión completada",
    "comment_added": "Comentario añadido",
    "document_uploaded": "Documento subido",
    "response_required": "Respuesta requerida"
  }
}
